import methodAPI from './methodAPI';

export const adminbannerAPI = {
    getAll: async () => {
        return await methodAPI.get('/banners');
    },

    create: async (bannerData) => {
        return await methodAPI.post('/banners', bannerData);
    },

    update: async (id, bannerData) => {
        return await methodAPI.put(`/banners/${id}`, bannerData);
    },

    delete: async (id) => {
        return await methodAPI.delete(`/banners/${id}`)
    }
};